/**
 * Theme Manager
 * Handles Light/Dark mode switching, persistence, and system sync.
 */
export default class ThemeManager {
    constructor() {
        this.toggleBtn = document.getElementById('theme-toggle');
        this.html = document.documentElement;
        this.icon = document.querySelector('.theme-icon');
        
        this.init();
    }

    init() {
        // 1. Check Local Storage
        const savedTheme = localStorage.getItem('theme');
        
        // 2. Check System Preference
        const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        
        // 3. Determine Initial Theme
        if (savedTheme) {
            this.setTheme(savedTheme);
        } else {
            this.setTheme(systemPrefersDark ? 'dark' : 'light');
        }

        // 4. Setup Event Listeners
        if (this.toggleBtn) {
            this.toggleBtn.addEventListener('click', () => this.toggleTheme());
        }

        // 5. Listen for System Changes
        // 5. Listen for System Changes
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
            const newTheme = e.matches ? 'dark' : 'light';
            this.setTheme(newTheme);
            localStorage.setItem('theme', newTheme);
        });
    }

    toggleTheme() {
        const currentTheme = this.html.getAttribute('data-theme');
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
        this.setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
    }

    setTheme(theme) {
        this.html.setAttribute('data-theme', theme);
        
        // Update Icon State
        if (theme === 'light') {
            this.icon.classList.add('sun-mode');
            this.icon.classList.remove('moon-mode');
        } else {
            this.icon.classList.add('moon-mode');
            this.icon.classList.remove('sun-mode');
        }
    }
}
